<template>
	<card>
		<template slot="header">
			<h4 class="mb-0">ยอดรวมรายการฝากเงิน</h4>
		</template>
		<template>
			<div class="row">
				<div class="col-md-6">
					<pie-chart
						:height="250"
						:chart-data="amountChart.chartData"
						:extra-options="amountChart.extraOptions"
					/>
				</div>
				<div class="col-md-6">
					<pie-chart
						:height="250"
						:chart-data="percentChart.chartData"
						:extra-options="percentChart.extraOptions"
					/>
				</div>
			</div>
		</template>
	</card>
</template>

<script>
import PieChart from '../../components/Charts/PieChart'

import { Charts } from '../../components/Charts/config'

export default {
	props: ['data'],
	components: {
		PieChart,
	},
	data() {
		return {
			amountChart: {
				chartData: {},
				extraOptions: {
					responsive: true,
				},
			},
			percentChart: {
				chartData: {},
				extraOptions: {
					responsive: true,
					tooltips: {
						callbacks: {
							label: (v) => {
								const chartData = this.percentChart.chartData
								const dataSets = chartData.datasets[v.datasetIndex]
								return `${chartData.labels[v.index]}: ${dataSets.data[v.index]}%`
							},
						},
					},
				},
			},
		}
	},
	methods: {
		updateChart(v) {
			this.amountChart.chartData = {
				labels: [
					`ธนาคาร`,
					`ทรูมันนี่วอลเล็ท`,
					`ธนาคาร (เติมมือ)`,
					`ทรูมันนี่วอลเล็ท (เติมมือ)`,
				],
				datasets: [
					{
						data: [
							Math.round(v.bankTotal * 100) / 100,
							Math.round(v.truewalletTotal * 100) / 100,
							Math.round(v.bankManualTotal * 100) / 100,
							Math.round(v.truewalletManualTotal * 100) / 100,
						],
						backgroundColor: [
							Charts.colors.theme['success'],
							Charts.colors.theme['info'],
							Charts.colors.theme['warning'],
							Charts.colors.theme['danger'],
						],
					},
				],
			}

			this.percentChart.chartData = {
				labels: [
					`ธนาคาร (เปอร์เซ็นต์)`,
					`ทรูมันนี่วอลเล็ท (เปอร์เซ็นต์)`,
					`ธนาคาร เติมมือ (เปอร์เซ็นต์)`,
					`ทรูมันนี่วอลเล็ท เติมมือ (เปอร์เซ็นต์)`,
				],
				datasets: [
					{
						data: [v.bank, v.truewallet, v.bankManual, v.truewalletManual],
						backgroundColor: [
							Charts.colors.theme['success'],
							Charts.colors.theme['info'],
							Charts.colors.theme['warning'],
							Charts.colors.theme['danger'],
						],
					},
				],
			}
		},
	},
	created() {
		this.updateChart(this.data)
	},
	watch: {
		data(v) {
			this.updateChart(v)
		},
	},
}
</script>
